export default __webpack_public_path__ + "static/media/rozliczenia_top.7b334b0e.jpg";